// extracted by mini-css-extract-plugin
module.exports = {"…":"Overflow_…__1-0x-"};